var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"loading",attrs:{"id":"loading"}},[_c('img',{staticClass:"spinner",attrs:{"src":"/themes/ito/images/loadding.png","alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }